import Api from 'utils/api'

export const deleteData = (model, pk) => Api.delete([model, pk])

export const fetchData = (model, pk, payload) => Api.get([model, pk], payload)

export const patchData = (model, pk, payload) => Api.patch([model, pk], payload)

export const postData = (model, pk, suffix, payload) =>
  Api.post([model, pk, suffix], payload)
